import { render } from "./index.vue?vue&type=template&id=35000680&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=35000680&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35000680"]])

export default __exports__